/**
 * @return {string} The path value of the current URL.
 */
function getPath() {
  return window.location.pathname + window.location.search;
}

export default getPath;
